import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { ManageCardsComponent } from "./managecards.component";
import { AuthGuard } from "../auth-guard.service";
import { AccountGuard } from "../account-guard.service";
import { LiveCardsComponent } from "./managedcards.livecards.component";
import { ManagedCardService } from "./managecards.service";
import { ManagedCardsNavigationComponent } from "./managedcards.navigation.component";
import { StopCardsComponent } from "./managedcards.stopcards.component";
import { ReduntantCardsComponent } from "./managedcards.reduntantcards.component";
import { PendingCardsComponent } from "./managedcards.pendingcards.component";
import { OrderCardsComponent } from "./managedcards.ordercards.component";
import { CardHistoryComponent } from "./managedcards.cardhistory.component";

@NgModule({
  imports:[      
      SharedModule,
      RouterModule.forChild([
          {path:'managecards',component: ManageCardsComponent, canActivate:[AuthGuard,AccountGuard]},
          { path: 'managecards/livecards', component: LiveCardsComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'managecards/ordercards', component: OrderCardsComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'managecards/stopcards', component: StopCardsComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'managecards/cardhistory', component: CardHistoryComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'managecards/pendingcards', component: PendingCardsComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'managecards/reduntantcards', component: ReduntantCardsComponent, canActivate: [AuthGuard, AccountGuard] }
      ])
    ],
    exports: [
        
    ],
    declarations: [
      ManageCardsComponent,
      LiveCardsComponent,
      ManagedCardsNavigationComponent,
      StopCardsComponent,
      ReduntantCardsComponent,
      PendingCardsComponent,
      OrderCardsComponent,
      CardHistoryComponent
    ],
    providers: [        
      ManagedCardService
    ]
})
export class ManageCardsModule{

}



// WEBPACK FOOTER //
// ./src/app/managecards/managecards.module.ts